<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_585" data-name="Rectangle 585" width="287.238" height="117.535" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_866" data-name="Rectangle 866" width="380" height="678"/>
    <text id="How_thought_leadership_gets_you_noticed" data-name="How thought leadership gets
you noticed" transform="translate(38 50.446)" fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">How thought leadership gets</tspan>
        <tspan x="0" y="28">you noticed</tspan>
    </text>
    <text id="Good_thought_leadership_positions_you_as_an_authority_on_the_issues_your_customers_are_wrestling_with_as_they_try_to_transform_their_businesses._When_looking_for_insight_they_can_trust_executives_in_our_survey_prioritise_three_things:"
          data-name="Good thought leadership positions you as an authority on the issues your customers are wrestling with as they try to transform their businesses. When looking for insight they can trust, executives in our survey prioritise three things:"
          transform="translate(38 120)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">Good thought leadership</tspan>
        <tspan x="0" y="46">positions you as an</tspan>
        <tspan x="0" y="74">authority on the issues</tspan>
        <tspan x="0" y="102">your customers are</tspan>
        <tspan x="0" y="130">wrestling with as they try to</tspan>
        <tspan x="0" y="158">transform their businesses.</tspan>
    </text>
    <g id="Group_1170" data-name="Group 1170" transform="translate(46 390)">
        <g id="Group_1169" data-name="Group 1169" clip-path="url(#clip-path)">
            <path id="Path_14569" data-name="Path 14569" d="M88.406,34.2a21.829,21.829,0,1,1-23.688.967" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14570" data-name="Path 14570"
                  d="M111.032,106.687V97.845A23.1,23.1,0,0,0,91.676,75.051a23.713,23.713,0,0,1-28.82-.14A23.1,23.1,0,0,0,42.49,97.845v18.328"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14571" data-name="Path 14571"
                  d="M76.278,11.5l5.383,10.908L93.7,24.155l-8.711,8.491,2.057,11.989L76.278,38.974,65.511,44.635l2.057-11.989-8.711-8.491L70.9,22.406Z"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14572" data-name="Path 14572" d="M41.061,86.6a50.141,50.141,0,1,1,70.91,0" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14573" data-name="Path 14573"
                  d="M1,116.535H114.058a32.412,32.412,0,0,0,22.919-9.493l23.7-23.7A32.407,32.407,0,0,1,183.6,73.845h31.849a32.411,32.411,0,0,0,22.918-9.493L286.238,16.48"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
    </g>
</svg>
